import React, { useState } from 'react';

const FianancialStrain = ({ onNext, answers, stepKey }) => {
  const [selectedAnswer, setSelectedAnswer] = useState(answers && answers[stepKey] ? answers[stepKey] : null);

  const handleClick = (value) => {
    setSelectedAnswer(value);
    onNext(value);
  };

  return (
    <>
      <div className="qs-card__head"><h2 className="qs-card__title">Financial Strain on Daily Life</h2></div>
      <div className="qs-card__body">
        <p className="qs-card__sub">Did your financial situation while repaying this loan ever affect your emotional wellbeing, mental health, or ability to cope day-to-day?</p>
        <div className="qs-actions">
          <button 
            type="button" 
            className={`qs-btn qs-btn--yes ${selectedAnswer == 512 ? 'btn-active' : ''}`}
            onClick={() => handleClick(512)}>
            Yes
          </button>
          <button 
            type="button" 
            className={`qs-btn qs-btn--no ${selectedAnswer == 513 ? 'btn-active' : ''}`}
            onClick={() => handleClick(513)}>
            No
          </button>
        </div>
      </div>
    </>
  );
};

export default FianancialStrain;
